import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = {
  class: "flex-shrink-0 p-3 bg-white m-0",
  style: {"width":"280px","min-height":"100vh"}
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<a class=\"d-flex align-items-center pb-3 mb-3 link-dark text-decoration-none border-bottom\" href=\"/\"><svg class=\"bi me-2\" width=\"30\" height=\"24\"><use xlink:href=\"#bootstrap\"></use></svg><img src=\"" + _imports_0 + "\" style=\"width:180px;height:auto;\"></a><h6 class=\"text-start px-3\">เมนู</h6>", 2)
const _hoisted_4 = { class: "list-unstyled ps-0 text-start" }
const _hoisted_5 = { class: "px-3 py-2 position-relative" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "จัดการหน้าแรก", -1)
const _hoisted_7 = { class: "px-3 py-2 position-relative" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "จัดการเกี่ยวกับเรา", -1)
const _hoisted_9 = { class: "px-3 py-2 position-relative" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "จัดการบทความและข่าวสาร", -1)
const _hoisted_11 = { class: "px-3 py-2 position-relative" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "จัดการสินค้า", -1)
const _hoisted_13 = { class: "px-3 py-2 position-relative" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "จัดการล่าม", -1)
const _hoisted_15 = { class: "px-3 py-2 position-relative" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "จัดการหมวดหมู่", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", _hoisted_5, [
        _createVNode(_component_router_link, {
          class: "portal-nav-item nav-item align-items-center rounded",
          to: "/portal/home"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_7, [
        _createVNode(_component_router_link, {
          class: "portal-nav-item nav-item align-items-center rounded",
          to: "/portal/about"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_9, [
        _createVNode(_component_router_link, {
          class: "portal-nav-item nav-item align-items-center rounded",
          to: "/portal/blog"
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_11, [
        _createVNode(_component_router_link, {
          class: "portal-nav-item nav-item align-items-center rounded",
          to: "/portal/product"
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_13, [
        _createVNode(_component_router_link, {
          class: "portal-nav-item nav-item align-items-center rounded",
          to: "/portal/service"
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_15, [
        _createVNode(_component_router_link, {
          class: "portal-nav-item nav-item align-items-center rounded",
          to: "/portal/category"
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        })
      ])
    ])
  ]))
}